/**
 * Extract the post sections based on the configuration
 *
 * @param {*} {
 *     showFeaturePost,
 *     showMostRecentBlock,
 *     posts = [],
 * }
 * @return {*}
 */
export const extractPostSections = ({ showFeaturePost, showMostRecentBlock, posts }) => {
    const currentDate = Date.now();

    const listing = posts.filter((post) => {
        if (!post.postingDate) return true;
        return post.postingDate <= currentDate;
    });

    const main = showFeaturePost ? listing.shift() : null;

    const mostRecent = showMostRecentBlock ? listing.splice(0, 4) : [];

    return {
        main,
        mostRecent,
        listing
    };
};

/**
 * Returns all category names from the list of categories
 *
 * @param {*} [categories=[]]
 * @return {string[]}
 */
export const getAllCategoryNames = (categories = []) => {
    return categories
        .map((cat) => {
            if (cat.categoryName) return cat.categoryName;
            const [name] = Object.values(cat);
            return name;
        })
        .filter(Boolean);
};

export const getFirstCategoryName = (categories = []) => {
    const firstCategory = categories[0];

    // If there is no category, return an empty string
    if (!firstCategory) {
        return '';
    }

    // Velocity code returns a `categoryName` property
    if (firstCategory.categoryName) {
        return firstCategory.categoryName;
    }

    // Otherwise, Content APO return a key-value pair
    const [categoryName] = Object.values(firstCategory);

    return categoryName;
};
